import { useState, type CSSProperties, type ReactElement } from 'react';

import { V4 } from '../../../tokens';

export interface SkipFooterProps {
  onSkip: () => void;
  disabled?: boolean;
  /** Texto del link. Default: "Lo hago después". */
  label?: string;
  /** Línea secundaria bajo el link (ej. promesa de guardado del avance). */
  hint?: string;
}

const wrapperStyle: CSSProperties = {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  marginTop: 16,
};

const baseLinkStyle: CSSProperties = {
  background: 'transparent',
  border: 'none',
  padding: 0,
  color: V4.secondary,
  fontSize: 13,
  fontWeight: 500,
  textDecoration: 'underline',
  cursor: 'pointer',
  textAlign: 'center',
};

export const SkipFooter = ({
  onSkip,
  disabled = false,
  label = 'Lo hago después',
  hint,
}: SkipFooterProps): ReactElement => {
  const [hover, setHover] = useState(false);

  return (
    <div data-testid="skip-footer" style={{ ...wrapperStyle, flexDirection: 'column', alignItems: 'center', gap: 4 }}>
      <button
        type="button"
        onClick={onSkip}
        disabled={disabled}
        style={{
          ...baseLinkStyle,
          color: disabled ? V4.grayUltraDark : hover ? V4.secondaryDark : V4.secondary,
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {label}
      </button>
      {hint ? <span style={{ fontSize: 11, color: V4.grayUltraDark }}>{hint}</span> : null}
    </div>
  );
};
